//Generated File 
export const AnalysisSet = `AnalysisSet`;
export const ApprovalDefinition = `ApprovalDefinition`;
export const Branch = `Branch`;
export const ConfigEntry = `ConfigEntry`;
export const Department = `Department`;
export const DocCategory = `DocCategory`;
export const DocumentBook = `DocumentBook`;
export const DocumentTerm = `DocumentTerm`;
export const Employee = `Employee`;
export const LegalEntity = `LegalEntity`;
export const MasterGroup = `MasterGroup`;
export const ReportDefinition = `ReportDefinition`;
export const Sector = `Sector`;
export const User = `User`;
